import { defineComponent, toRaw } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'filter-indikator-group-price-range',
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        setFilters: 'UPDATE_FILTERS',
    })), { clearFilter() {
            var _a, _b, _c, _d;
            const filters = structuredClone(toRaw(this.appliedFilters));
            filters.priceRange = null;
            this.setFilters(filters);
            eventBus.emit('priceRange:loaded', {
                min: (_b = (_a = [...this.priceBars].shift()) === null || _a === void 0 ? void 0 : _a.minPrice) !== null && _b !== void 0 ? _b : 0,
                max: (_d = (_c = [...this.priceBars].pop()) === null || _c === void 0 ? void 0 : _c.maxPrice) !== null && _d !== void 0 ? _d : 0,
            });
        } }),
    computed: Object.assign({}, mapGetters('blue', {
        appliedFilters: 'appliedFilters',
        priceBars: 'priceBars',
    })),
});
